/**
 * `{{key}}` placeholder helpers for per-assignee variables.
 * Output is plain text (React-escaped when rendered), never HTML.
 */

export const VARIABLE_KEY_PATTERN = /^[a-zA-Z][a-zA-Z0-9_]{0,31}$/;

// Fresh regex per call: a shared /g regex carries lastIndex state.
function placeholderRegex(): RegExp {
  return /\{\{\s*([a-zA-Z][a-zA-Z0-9_]{0,31})\s*\}\}/g;
}

/** Unique placeholder keys, in order of first appearance. */
export function findPlaceholders(text: string): string[] {
  const seen = new Set<string>();
  for (const m of text.matchAll(placeholderRegex())) seen.add(m[1]);
  return [...seen];
}

/** Substitute values; missing or blank values render as a visible `[key]` marker. */
export function renderTemplate(text: string, values: Record<string, string> | undefined): string {
  return text.replace(placeholderRegex(), (_m, key: string) => {
    const v = values?.[key];
    return v !== undefined && v.trim() !== '' ? v : `[${key}]`;
  });
}
